import PlayInListItem from './PlayInListItem'
import { connect } from 'react-redux'
import { addToPlayInList, removeFromPlayInList } from '../../dataStore/slices/playIn/playInSlice'

const mapDispatchToProps = dispatch => ({
  onAddClick: videoId => dispatch(addToPlayInList(videoId)),
  onRemoveClick: videoId => dispatch(removeFromPlayInList(videoId))
})

export default connect(null, mapDispatchToProps)(PlayInListItem)
